import React from 'react';
import Card from './Card';
import styles from "./Card.module.css";

function CardSimple({ lien, image, titre, rows = []}) {
    return (
        <Card lien={lien} image={image}>
            <h3 className={styles.cardTitle}>{titre}</h3>

            {rows.map((row, index) => (
                <span key={index}>{row}</span>
            ))}
        </Card>
    );
}

export default CardSimple;
